<template>
  <b-modal
    id="change-email"
    ref="change-email"
    size="entry-delete"
    title="Change Email Address"
    no-close-on-esc
    no-close-on-backdrop
    centered
    hide-footer
    hide-header
    @hide="close"
  >
    <div class="modal-head">
      <span class="modal-title">{{ label.get('change_email_address') }}</span>
    </div>
    <div class="content-wrapper password-confirm">
      <p>{{ label.get('change_email_address_description') }}</p>
      <div class="info-field">
        <input
          v-model="changeEmailPassword"
          type="password"
          :placeholder="label.get('please_enter_your_password_input_placeholder')"
          autofocus
          @keyup.enter="handleConfirmModal"
        >
      </div>
      <span
        v-if="modalErrorPasswordMessage"
        class="error-message"
      >{{ modalErrorPasswordMessage }}</span>
    </div>
    <div class="modal-footer">
      <button
        type="submit"
        class="atto-btn cancel"
        @click="close"
      >
        {{ label.get('cancel') }}
      </button>
      <button
        type="submit"
        class="atto-btn submit"
        :disabled="disableSubmitButton"
        @click="handleConfirmModal"
      >
        {{ label.get('submit') }}
      </button>
    </div>
  </b-modal>
</template>

<script>
    import UserService from "../../services/UserService";

    export default {
        name: "EmailChangeConfirmPasswordComponent",
        data() {
            return {
                changeEmailPassword: null,
                modalErrorPasswordMessage: null,
                disableSubmitButton: false
            };
        },
        mounted() {
            document.body.appendChild(this.$el);
            this.$refs['change-email'].show();
        },
        methods: {
            close() {
                this.$root.$emit('hideEmailChangeConfirm');
            },
            handleConfirmModal() {
                this.disableSubmitButton = true;
                if (!this.changeEmailPassword) {
                    this.modalErrorPasswordMessage = this.label.get('please_enter_your_password_input_placeholder');
                } else {
                    this.modalErrorPasswordMessage = '';
                    let params = {
                        old_password: this.changeEmailPassword,
                    };

                    this.$store.commit('showLoading');
                    UserService.checkUserOldPassword(params).then((result) => {
                            this.changeEmailPassword = '';
                            this.$root.$emit('hideEmailChangeConfirm', true);
                        }).catch((error) => {
                            this.$store.commit('hideLoading');
                            this.disableSubmitButton = false;
                            if (error.response.data.error.old_password) {
                                this.modalErrorPasswordMessage = error.response.data.error.old_password[0]
                            }
                            this.modalErrorPasswordMessage = this.label.get('password_is_incorrect');
                        });
                }

            }
        }
    }
</script>

<style scoped>

</style>